import React from 'react';

import { CmBox, CmText } from '@/components/uiParts';
import { CloseIcon } from '@/components/uiParts';

interface Props {
  groupIndex: number;
  handleRemoveMask: (groupIndex: number) => void;
}
export const ExpectedDeleteMask: React.FC<Props> = ({
  groupIndex,
  handleRemoveMask,
}) => {
  return (
    <CmBox
      position="absolute"
      top="0"
      bg="rgb(255, 0, 0, 0.7)"
      left="0"
      right="0"
      bottom="0"
      zIndex="2"
      onClick={(e) => e.stopPropagation()}
    >
      <CloseIcon
        position="absolute"
        top="15px"
        right="15px"
        height="9"
        minWidth="8"
        z-index="2"
        color="white"
        onClick={(e) => {
          e.stopPropagation();
          handleRemoveMask(groupIndex);
        }}
      />
      <CmText
        position="absolute"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        color="white"
        fontSize="30px"
      >
        削除予定
      </CmText>
    </CmBox>
  );
};
